import { Text } from '@lmc/ui-kit/src/general'
import { SHIFT, VISIT } from 'screens/Rostering/constants'
import {
  getDateTimeInZone,
  TIME_FORMAT
} from 'screens/Rostering/utils.datetime'
import styled from 'styled-components'

type EventCardProps = {
  event?: any
  onClick?: () => void
}

const EventCard = ({ event, onClick }: EventCardProps) => {
  if (!event) return null

  const type = event.siteShift ? SHIFT : VISIT

  return (
    <CardContainer
      data-testid="event-card"
      clickable={!!onClick}
      onClick={onClick ? () => onClick() : undefined}
    >
      <Text level={1.5} weight="bold">
        {type === SHIFT
          ? event.title
          : `${event.resident?.first} ${event.resident?.last}`}
      </Text>
      <Text level={2}>
        {`${getDateTimeInZone(event.startTime).format(
          TIME_FORMAT
        )} - ${getDateTimeInZone(event.endTime).format(TIME_FORMAT)} · ${
          event.expectedDuration
        }`}
      </Text>
      <LightText level={2}>{event.instanceType}</LightText>
    </CardContainer>
  )
}

const CardContainer = styled.div<{ clickable: boolean }>`
  display: flex;
  flex-direction: column;
  width: 160px;
  padding: 8px;
  border-radius: 4px;
  border: 0.5px solid ${(props) => props.theme.color.neutral.color7};
  color: ${(props) => props.theme.color.neutral.color3};

  &:hover {
    border-color: ${(props) =>
      props.clickable
        ? props.theme.color.status.primary
        : props.theme.color.neutral.color7};
    cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
  }
`

const LightText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color4};
`

export default EventCard
